import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function ATM({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M4.66667 2.66667C4.29848 2.66667 4 2.96515 4 3.33334V21.3333H5.33333V4.00001H18.6667V12.6667H10.6667V14H12V17.3333C12 17.7015 12.2985 18 12.6667 18H16.6667C17.0349 18 17.3333 17.7015 17.3333 17.3333V14H18.6667V20H7.33333V21.3333H19.3333C19.7015 21.3333 20 21.0349 20 20.6667V3.33334C20 2.96515 19.7015 2.66667 19.3333 2.66667H4.66667ZM13.3333 16.6667V14H16V16.6667H13.3333Z"
        fill={iconColor}
      />
      <Path
        d="M7.33333 5.33334C6.96514 5.33334 6.66667 5.63182 6.66667 6.00001V10.6667C6.66667 11.0349 6.96514 11.3333 7.33333 11.3333H16.6667C17.0349 11.3333 17.3333 11.0349 17.3333 10.6667V6.00001C17.3333 5.63182 17.0349 5.33334 16.6667 5.33334H7.33333ZM8 10V6.66667H16V10H8Z"
        fill={iconColor}
      />
    </Svg>
  );
}
